<div class="row contenedor-detalle-siniestro mx-1 mt-2 border-naranja-seccion">
    <div class="col-lg-4 col-md-12 col-sm-12 col-12 my-3"  [ngClass]="{' borde-derecho' : !['xs', 'sm', 'md'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">CONDUCTOR</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 d-flex align-items-center mt-2 mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo">Nombre : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.nombre_conductor}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo">Teléfono : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.telef_conductor}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                <div class="flex-grow-1 d-flex justify-content-between">
                    <small class="titulo">Causa : </small>
                    <strong class="valorTextoWeight-500">{{siniestroCompleto?.desc_causa}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-8 col-md-12 col-sm-12 col-12 my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">DETALLE ADICIONALES</small>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9">
                <div class="row mb-2">
                    <div class="col-md-12 col-12 d-flex align-items-center mt-2 mb-2">
                        <div class="flex-grow-1 d-flex justify-content-between">
                            <small class="titulo">Agente : </small>
                            <strong class="valorTextoWeight-500">{{siniestroCompleto?.agente}}</strong>
                            <strong class="valorTextoWeight-500">{{siniestroCompleto?.desc_agente}}</strong>
                        </div>
                    </div>
                    <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                        <div class="flex-grow-1 d-flex justify-content-between">
                            <small class="titulo">Contratante : </small>
                            <strong class="valorTextoWeight-500">{{' '}}</strong>
                            <strong class="valorTextoWeight-500">{{siniestroCompleto?.desc_contratante}}</strong>
                        </div>
                    </div>
                    <div class="col-md-12 col-12 d-flex align-items-center mb-2">
                        <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                            <small class="titulo">Ajustador : </small>
                            <strong class="valorTextoWeight-500">{{siniestroCompleto?.numero}}</strong>
                            <strong class="valorTextoWeight-500">{{siniestroCompleto?.desc_ajustador}}</strong>
                            <button mat-mini-fab color="accent" (click)="abrirModalAjustadores()">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3" [formGroup]="formDetalleAdicionales">
                <mat-checkbox formControlName="lesionados" [checked]="this.siniestroCompleto?.lesionados == 1 ? true : false">Lesionados</mat-checkbox>
                <mat-checkbox formControlName="homicidio" [checked]="this.siniestroCompleto?.homicidio == 1 ? true : false">Homicidios</mat-checkbox>
            </div>
        </div>
    </div>
</div>